import { Tooltip, TooltipContent, TooltipTrigger } from "ui";

import { type AthleteProduct } from "src/helpers/athleteProductState";

import { AthleteProductHiddenRow } from "./AthleteProductHiddenRow";
import { AthleteProductTag } from "./AthleteProductTag";

const VISIBLE_PRODUCTS = 2;

interface AthleteProductsCellProps {
  products: AthleteProduct[];
}

export function AthleteProductsCell(props: AthleteProductsCellProps) {
  if (props.products.length === 0) {
    return "-";
  }

  const visible = props.products.slice(0, VISIBLE_PRODUCTS);
  const hidden = props.products.slice(VISIBLE_PRODUCTS);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((product) => {
        return <AthleteProductTag key={product.id} product={product} />;
      })}
      {hidden.length > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="text-xs font-medium text-muted-foreground">
              +{hidden.length}
            </span>
          </TooltipTrigger>
          <TooltipContent className="flex flex-col items-start gap-1">
            {hidden.map((product) => {
              return (
                <AthleteProductHiddenRow key={product.id} product={product} />
              );
            })}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
